import { render, staticRenderFns } from "./D009.vue?vue&type=template&id=a45035dc&scoped=true&"
import script from "./D009.vue?vue&type=script&lang=js&"
export * from "./D009.vue?vue&type=script&lang=js&"
import style0 from "./D009.vue?vue&type=style&index=0&id=a45035dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45035dc",
  null
  
)

export default component.exports